import { render, staticRenderFns } from "./protocolo-processo-componente.vue?vue&type=template&id=4aae111d"
import script from "./protocolo-processo-componente.vue?vue&type=script&lang=js"
export * from "./protocolo-processo-componente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports